export const mediaManager = (csrfToken: string) => ({
  selectedPhotos: [] as string[],
  selectedUrls: [] as string[],
  selectedKeys: [] as string[],

  deleteSelected() {
    if ((this.selectedKeys as string[]).length === 0) return;
    if (!confirm("Are you sure you want to delete the selected photos?")) return;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/media";
    form.style.display = "none";
    document.body.appendChild(form);

    (this.selectedKeys as string[]).forEach((key: string) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "key[]";
      input.value = key;
      form.appendChild(input);
    });

    const csrf = document.createElement("input");
    csrf.type = "hidden";
    csrf.name = "_csrf_token";
    csrf.value = csrfToken;
    form.appendChild(csrf);

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "delete";
    form.appendChild(methodInput);

    form.submit();
  },

  clearSelections() {
    this.$dispatch("clear-selections");
    this.selectedPhotos = [];
    this.selectedUrls = [];
    this.selectedKeys = [];
  },

  newPost() {
    window.location.href =
      "/posts/new?" +
      (this.selectedUrls as string[])
        .map((url: string) => "selected_urls[]=" + encodeURIComponent(url))
        .join("&");
  },
});

export const mediaSelection = () => ({
  isSelected: false,
  showTools: false,

  toggleSelection() {
    this.isSelected = !this.isSelected;
    if (this.isSelected) {
      (this.selectedPhotos as string[]).push(this.$el.getAttribute("id") ?? "");
      (this.selectedKeys as string[]).push(this.$el.getAttribute("key") ?? "");
      (this.selectedUrls as string[]).push(this.$el.getAttribute("path") ?? "");
    } else {
      this.selectedPhotos = (this.selectedPhotos as string[]).filter(
        (id: string) => id !== this.$el.getAttribute("id"),
      );
      this.selectedKeys = (this.selectedKeys as string[]).filter(
        (key: string) => key !== this.$el.getAttribute("key"),
      );
      this.selectedUrls = (this.selectedUrls as string[]).filter(
        (url: string) => url !== this.$el.getAttribute("path"),
      );
    }
  },
});
